import { getBaseApi } from "../BaseApi";

export interface OrderEntityStats {
  totalOrders: number;
  confirmedOrders: number;
  confirmationRate: number | null;
  orderSharePercent: number | null;
}

export interface InventoryStatsResponse {
  kind: "product" | "affiliate" | "expedition" | "request";
  country?: string;
  entity: Record<string, unknown>;
  statsScope: "product" | "affiliate" | null;
  linkedProduct?: Record<string, unknown> | null;
  linkedProductId?: string | null;
  orderStats: OrderEntityStats | null;
  statusBreakdown: Record<string, number>;
  shippingBreakdown?: Record<string, number>;
  financialStats?: {
    profit: number;
    deliveryFees: number;
    currency: string;
  };
  sellerStats?: {
    distinctSellerCount: number;
    sellers: Array<{
      sellerId: string;
      name: string | null;
      email: string | null;
      platformId: string | null;
      orderCount: number;
    }>;
  };
  recentOrders: Array<{
    _id?: string;
    orderId?: string;
    status?: string;
    customerName?: string;
    totalPrice?: number;
    createdAt?: string;
    quantity?: number;
  }>;
  recentShippings?: Array<{
    _id?: string;
    orderId?: string;
    status?: string;
    customerName?: string;
    createdAt?: string;
    quantity?: number;
  }>;
  message?: string;
}

/** Agrégations commandes lourdes : même logique que stock/summary (délai > défaut Axios 30s). */
const INVENTORY_STATS_REQUEST_MS = 120_000;

export function getInventoryStats(kind: string, id: string, country?: string) {
  const params: Record<string, string> = {};
  if (country) params.country = country;
  return getBaseApi().axiosInstance.get(`inventory-stats/${kind}/${id}`, {
    params,
    timeout: INVENTORY_STATS_REQUEST_MS,
  });
}
